package com.evoapps.evoshift.ui.user

import androidx.compose.material.icons.filled.Home

import evoshift.composeapp.generated.resources.schedule_shift_at
import evoshift.composeapp.generated.resources.interview_title
import evoshift.composeapp.generated.resources.interview_when
import evoshift.composeapp.generated.resources.interview_candidate
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.ui.util.monthInDateRes
import com.evoapps.evoshift.ui.util.inMonth
import androidx.compose.material3.pulltorefresh.PullToRefreshBox
import com.evoapps.evoshift.domain.usecase.finance.ShiftPayChange
import com.evoapps.evoshift.ui.finance.formatMoney
import androidx.compose.material3.minimumInteractiveComponentSize
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.animation.animateColorAsState
import androidx.compose.runtime.key
import com.evoapps.evoshift.ui.theme.motionTween
import com.evoapps.evoshift.ui.theme.MotionContent
import com.evoapps.evoshift.ui.theme.motionContentSize
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.LocalTopBarSelection
import evoshift.composeapp.generated.resources.shift_note_from_manager
import evoshift.composeapp.generated.resources.top_bar_no_roster
import kotlinx.datetime.number
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import androidx.compose.foundation.BorderStroke
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.widgets.LocalContextSwitcher
import com.evoapps.evoshift.widgets.parseClockTime
import com.evoapps.evoshift.widgets.EvoTimeField
import com.evoapps.evoshift.widgets.EvoSecondaryButton
import com.evoapps.evoshift.widgets.EvoPrimaryButton
import com.evoapps.evoshift.widgets.EvoListRow
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoBottomSheet
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.domain.util.plannedTimeRange
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.material.icons.filled.SwapHoriz
import androidx.compose.material.icons.automirrored.filled.Undo
import androidx.compose.material.icons.filled.Storefront
import androidx.compose.material.icons.filled.CalendarToday
import evoshift.composeapp.generated.resources.schedule_available_count
import org.jetbrains.compose.resources.pluralStringResource
import com.evoapps.evoshift.ui.util.dayAndDate
import com.evoapps.evoshift.domain.util.AppClock
import com.evoapps.evoshift.ui.adaptive.ListMaxWidth
import com.evoapps.evoshift.ui.calendar.CalendarFocusRing
import com.evoapps.evoshift.ui.calendar.monthCalendarDay
import com.evoapps.evoshift.ui.calendar.monthCalendarKeys
import com.evoapps.evoshift.ui.calendar.rememberMonthCalendarState
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.PostureAwareScaffold
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.TwoPane
import com.evoapps.evoshift.ui.adaptive.DetailPane
import com.evoapps.evoshift.ui.adaptive.DetailPaneBack
import com.evoapps.evoshift.ui.adaptive.DevicePosture
import com.evoapps.evoshift.ui.adaptive.LocalDevicePosture
import com.evoapps.evoshift.ui.adaptive.PaneDivider
import com.evoapps.evoshift.ui.adaptive.PanePlaceholder
import com.evoapps.evoshift.ui.adaptive.PaneTags
import com.evoapps.evoshift.ui.adaptive.ProvideWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.showsDetailPane
import androidx.compose.ui.platform.testTag
import androidx.compose.foundation.layout.fillMaxHeight
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.adaptive.cardClickable
import com.evoapps.evoshift.ui.util.asString
import evoshift.composeapp.generated.resources.cancel
import evoshift.composeapp.generated.resources.employee
import evoshift.composeapp.generated.resources.roster_shift_details
import evoshift.composeapp.generated.resources.schedule_cant_work
import evoshift.composeapp.generated.resources.schedule_manager_note
import evoshift.composeapp.generated.resources.schedule_marketplace_request_at
import evoshift.composeapp.generated.resources.schedule_marketplace_shifts
import evoshift.composeapp.generated.resources.schedule_my_shift_details
import evoshift.composeapp.generated.resources.schedule_my_shifts
import evoshift.composeapp.generated.resources.schedule_put_on_marketplace
import evoshift.composeapp.generated.resources.schedule_select_person
import evoshift.composeapp.generated.resources.schedule_shifts_for
import evoshift.composeapp.generated.resources.schedule_show_my_shifts
import evoshift.composeapp.generated.resources.schedule_swap_change
import evoshift.composeapp.generated.resources.schedule_swap_status_requested
import evoshift.composeapp.generated.resources.schedule_swap_with_person
import evoshift.composeapp.generated.resources.schedule_waiting_for_approval_from
import evoshift.composeapp.generated.resources.shift
import evoshift.composeapp.generated.resources.status_value
import com.evoapps.evoshift.ui.util.label
import com.evoapps.evoshift.ui.util.monthName
import com.evoapps.evoshift.ui.util.dayShort
import evoshift.composeapp.generated.resources.roster_from
import evoshift.composeapp.generated.resources.roster_to
import evoshift.composeapp.generated.resources.schedule_actual_hours
import evoshift.composeapp.generated.resources.schedule_marketplace_empty
import evoshift.composeapp.generated.resources.schedule_take_shift
import evoshift.composeapp.generated.resources.schedule_update_hours
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.IntrinsicSize
import com.evoapps.evoshift.domain.model.SwapRequest
import com.evoapps.evoshift.domain.model.SwapStatus
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.ShoppingBag
import androidx.compose.material.icons.filled.Work
import androidx.compose.material.icons.filled.Event
import evoshift.composeapp.generated.resources.add_to_calendar
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.model.TimeRange
import com.evoapps.evoshift.domain.model.ShiftBreak
import com.evoapps.evoshift.domain.model.BreakRules
import com.evoapps.evoshift.domain.model.workerId
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.roster.getDaysInMonth
import com.evoapps.evoshift.viewmodels.ScheduleEvent
import com.evoapps.evoshift.viewmodels.ScheduleViewModel
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.app_name
import evoshift.composeapp.generated.resources.dashboard_profile
import evoshift.composeapp.generated.resources.dashboard_switch
import evoshift.composeapp.generated.resources.day_friday
import evoshift.composeapp.generated.resources.day_monday
import evoshift.composeapp.generated.resources.day_saturday
import evoshift.composeapp.generated.resources.day_sunday
import evoshift.composeapp.generated.resources.day_thursday
import evoshift.composeapp.generated.resources.day_tuesday
import evoshift.composeapp.generated.resources.day_wednesday
import evoshift.composeapp.generated.resources.schedule_my_shift
import evoshift.composeapp.generated.resources.schedule_no_rosters
import evoshift.composeapp.generated.resources.schedule_no_shifts
import evoshift.composeapp.generated.resources.schedule_open_shift
import androidx.compose.material3.*
import com.evoapps.evoshift.domain.model.User
import evoshift.composeapp.generated.resources.*
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDate
import kotlinx.datetime.Month
import kotlinx.datetime.isoDayNumber
import org.jetbrains.compose.resources.stringResource
import evoshift.composeapp.generated.resources.schedule_hours_by_manager

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ScheduleScreen(
    viewModel: ScheduleViewModel,
    initialShowMarketplace: Boolean = false,
    onNavigateToProfile: () -> Unit,
    /** Null at the My shifts tab; reached from More (owners, managers), it has a back arrow (SH-110). */
    onNavigateBack: (() -> Unit)? = null,
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()

    if (state.showSwapDialog) {
        SwapOptionsDialog(
            candidates = state.swapCandidates,
            role = state.swapRole,
            payChange = state.swapTargetShiftId?.let { state.payChanges[it] },
            currency = state.currency,
            onDismiss = { viewModel.onEvent(ScheduleEvent.ShowSwapDialog("", false)) },
            onPutOnMarketplace = { note ->
                state.swapTargetShiftId?.let {
                    viewModel.onEvent(ScheduleEvent.RequestSwap(it, note = note))
                }
            },
            onSwapWithPerson = { userId, note ->
                state.swapTargetShiftId?.let {
                    viewModel.onEvent(ScheduleEvent.RequestSwap(it, userId, note))
                }
            }
        )
    }

    var showCalendar by remember { mutableStateOf(false) }
    val calendarRoster = state.publishedRosters.find { it.id == state.currentRosterId }
    if (showCalendar) {
        // SH-202: "Your shifts in your calendar", with a published month's .ics file too.
        com.evoapps.evoshift.ui.calendar.CalendarSubscriptionDialog(
            onDismiss = { showCalendar = false },
            month = calendarRoster?.let {
                com.evoapps.evoshift.ui.calendar.CalendarFileMonth(it.id, "${monthName(it.month)} ${it.year}")
            }
        )
    }

    val snackbarHostState = remember { SnackbarHostState() }
    val scope = rememberCoroutineScope()

    val contextSwitcher = LocalContextSwitcher.current

    val errorText = (state.error ?: state.message)?.asString()

    LaunchedEffect(errorText) {
        errorText?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(ScheduleEvent.ClearError)
        }
    }

    val sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
    var showMarketplaceOnly by remember { mutableStateOf(initialShowMarketplace) }
    // SH-161: the month by keyboard (one focus stop, arrows between days, Enter opens the day).
    val calendar = rememberMonthCalendarState()


    // SH-105: on expanded and wider windows (ordinary posture) the chosen day and shift open in a
    // pane beside the month and the list, instead of bottom sheets.
    val paneMode = LocalWindowWidthClass.current.showsDetailPane && LocalDevicePosture.current == DevicePosture.Normal
    val dayTitle = run {
        val roster = state.publishedRosters.find { it.id == state.currentRosterId }
        val monthName = roster?.month?.let { stringResource(monthInDateRes(it)) } ?: ""
        stringResource(Res.string.schedule_shifts_for, "${state.selectedDay} $monthName")
    }
    // The chosen day's shifts: in the sheet on phones, in the pane on wide windows.
    val dayContent: @Composable ColumnScope.() -> Unit = {
            if (state.selectedDayShifts.isEmpty()) {
                Text(
                    stringResource(Res.string.schedule_no_shifts),
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color.White.copy(alpha = 0.6f),
                    modifier = Modifier.padding(vertical = 16.dp)
                )
            } else {
                state.selectedDayShifts.forEach { shift ->
                    ShiftItemCard(
                        shift = shift,
                        isMyShift = shift.workerId == state.currentUserId,
                        onClick = { viewModel.onEvent(ScheduleEvent.SelectShift(shift)) },
                        // SH-223: remote work or a work event that day (the person's own approved request).
                        workMarks = if (shift.workerId == state.currentUserId) state.workMarksOn(shift.date) else emptySet(),
                        place = state.places[shift.id]
                    )
                }
            }
    }
    // The chosen shift: its times, giving it away or taking it from the marketplace.
    val shiftContent: @Composable ColumnScope.(Shift) -> Unit = { shift ->
        // SH-136: theirs when they work it (also recorded afterwards as who worked it); hours and
        // swaps only on a shift assigned to them that nobody else was recorded on.
        val isMyShift = shift.workerId == state.currentUserId
        val canChange = isMyShift && shift.userId == state.currentUserId
        val isMarketplace = shift.swapRequest?.status == SwapStatus.AVAILABLE && shift.userId != state.currentUserId
            ShiftItemCard(shift = shift, isMyShift = isMyShift, showDate = true, workMarks = if (isMyShift) state.workMarksOn(shift.date) else emptySet(), place = state.places[shift.id])
            // SH-165: opened straight from the calendar: the rest of that day one tap away.
            if (state.dayListHidden && state.selectedDayShifts.size > 1) {
                TextButton(onClick = { viewModel.onEvent(ScheduleEvent.ShowWholeDay) }, modifier = Modifier.handCursor()) {
                    Text(stringResource(Res.string.schedule_show_whole_day), color = LightGold)
                }
            }
            // SH-118: the manager's note for the person on this shift.
            if (isMyShift) state.shiftNotes[shift.id]?.let { note ->
                DialogSection(stringResource(Res.string.shift_note_from_manager)) {
                    Text(note, color = Color.White.copy(alpha = 0.9f))
                }
            }
            // The breaks the person registered on this shift.
            if (isMyShift) MyBreaksList(shift.breaks)

            // Read-only once the workplace's plan ended (SH-65): the shift, nothing to change.
            val canTrade = state.capabilities.shows(Gate.TRADE_SHIFTS)
            if (canChange && canTrade && state.ownHoursByManager && !state.workHours.selfEntry) {
                // SH-106: hours here are clocked with the location check; corrections are the manager's.
                DialogSection(stringResource(Res.string.schedule_actual_hours)) {
                    Text(stringResource(Res.string.schedule_hours_by_manager), color = Color.White.copy(alpha = 0.85f))
                }
            }
            // SH-257: where the workplace lets the team enter their own hours, they go to a manager to confirm.
            val selfEntry = isMyShift && canTrade && state.workHours.selfEntry
            if (selfEntry) SelfEnteredHours(shift, open = viewModel.selfEntryOpen(shift)) { range ->
                viewModel.onEvent(ScheduleEvent.ReportWorkHours(shift.id, range))
            }
            // SH-165: hours only once the shift has started (before, they would repeat the plan).
            val hoursOpen = viewModel.hoursOpen(shift)
            if (canChange && canTrade && !state.ownHoursByManager && hoursOpen && !selfEntry) {
                val base = shift.actualTime ?: shift.plannedTime
                var actualStart by remember(shift.id) { mutableStateOf(base.start.substring(11, 16)) }
                var actualEnd by remember(shift.id) { mutableStateOf(base.end.substring(11, 16)) }
                val start = parseClockTime(actualStart)
                val end = parseClockTime(actualEnd)
                val sameTimes = start != null && start == end

                DialogSection(stringResource(Res.string.schedule_actual_hours)) {
                    Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                        EvoTimeField(
                            value = actualStart,
                            onValueChange = { actualStart = it },
                            label = stringResource(Res.string.roster_from),
                            showErrors = true,
                            modifier = Modifier.weight(1f)
                        )
                        EvoTimeField(
                            value = actualEnd,
                            onValueChange = { actualEnd = it },
                            label = stringResource(Res.string.roster_to),
                            showErrors = true,
                            error = stringResource(Res.string.time_same_start_end).takeIf { sameTimes },
                            imeAction = ImeAction.Done,
                            modifier = Modifier.weight(1f)
                        )
                    }
                    EvoPrimaryButton(
                        DialogAction(
                            stringResource(Res.string.schedule_update_hours),
                            {
                                if (start != null && end != null && !sameTimes) {
                                    // A shift ending at or before its start ends the next day.
                                    val range = plannedTimeRange(LocalDate.parse(shift.date), start, end)
                                    viewModel.onEvent(ScheduleEvent.UpdateActualTime(shift.id, range))
                                }
                            },
                            enabled = start != null && end != null && !sameTimes
                        ),
                        Modifier.fillMaxWidth()
                    )
                }
            }
            if (canChange && canTrade) {
                if (shift.swapRequest == null) {
                    DialogSection(stringResource(Res.string.schedule_cant_work)) {
                        // SH-165: what giving it away or swapping it does to the month's pay.
                        PayChangeLine(state.payChanges[shift.id], state.currency)
                        EvoSecondaryButton(
                            DialogAction(
                                stringResource(Res.string.schedule_swap_change),
                                { viewModel.onEvent(ScheduleEvent.ShowSwapDialog(shift.id, true)) },
                                icon = Icons.Default.SwapHoriz
                            ),
                            Modifier.fillMaxWidth()
                        )
                    }
                } else {
                    Text(
                        text = stringResource(Res.string.status_value, shift.swapRequest!!.status.label()),
                        style = MaterialTheme.typography.bodyMedium,
                        color = LightGold,
                        fontWeight = FontWeight.Bold
                    )
                    // SH-165: the person's own note on the request.
                    shift.swapRequest?.initiatorNote?.takeIf { it.isNotBlank() }?.let { own ->
                        Text(
                            text = stringResource(Res.string.swap_note_value, own),
                            style = MaterialTheme.typography.bodyMedium,
                            color = Color.White.copy(alpha = 0.85f)
                        )
                    }
                    // SH-164: the manager's reason for a rejection.
                    val note = shift.swapRequest?.managerNote
                    if (!note.isNullOrBlank()) {
                        Text(
                            text = stringResource(Res.string.schedule_manager_note, note),
                            style = MaterialTheme.typography.bodyMedium,
                            color = Color.White.copy(alpha = 0.85f)
                        )
                    }
                    // SH-165: changed their mind while it still waits.
                    if (viewModel.canWithdraw(shift)) {
                        EvoSecondaryButton(
                            DialogAction(
                                stringResource(Res.string.schedule_swap_withdraw),
                                { viewModel.onEvent(ScheduleEvent.WithdrawSwap(shift.id)) },
                                icon = Icons.AutoMirrored.Filled.Undo
                            ),
                            Modifier.fillMaxWidth()
                        )
                    }
                }
            } else if (isMarketplace && canTrade) {
                // SH-165: the giver's note, for the colleague taking it.
                shift.swapRequest?.initiatorNote?.takeIf { it.isNotBlank() }?.let { note ->
                    Text(stringResource(Res.string.swap_note_value, note), color = Color.White.copy(alpha = 0.85f))
                }
                // SH-165: what taking it does to the month's pay.
                PayChangeLine(state.payChanges[shift.id], state.currency)
                EvoPrimaryButton(
                    DialogAction(stringResource(Res.string.schedule_take_shift), { viewModel.onEvent(ScheduleEvent.TakeShift(shift.id)) }),
                    Modifier.fillMaxWidth()
                )
            }
    }
    @Composable
    fun shiftTitle(shift: Shift): String =
        if (shift.workerId == state.currentUserId) stringResource(Res.string.schedule_my_shift_details) else stringResource(Res.string.roster_shift_details)
    fun shiftIcon(shift: Shift) = if (shift.workerId == state.currentUserId) Icons.Default.Person else Icons.Default.Work

    // SH-165: hidden behind a shift opened straight from the calendar.
    if (state.selectedDay != null && !paneMode && !(state.dayListHidden && state.selectedShift != null)) {
        EvoBottomSheet(
            onDismiss = { viewModel.onEvent(ScheduleEvent.ClearDay) },
            title = dayTitle,
            icon = Icons.Default.CalendarToday,
            sheetState = sheetState,
            headerActions = {
                IconButtonWithTooltip(
                    onClick = {
                        scope.launch { sheetState.hide() }.invokeOnCompletion {
                            viewModel.onEvent(ScheduleEvent.ClearDay)
                        }
                    },
                    modifier = Modifier.handCursor(),
                    tooltip = stringResource(Res.string.close)
                ) {
                    Icon(Icons.Default.Close, stringResource(Res.string.close), tint = Color.White.copy(alpha = 0.8f))
                }
            }
        ) {
            dayContent()
        }
    }

    state.selectedShift?.takeIf { !paneMode }?.let { shift ->
        EvoBottomSheet(
            onDismiss = { viewModel.onEvent(ScheduleEvent.SelectShift(null)) },
            title = shiftTitle(shift),
            icon = shiftIcon(shift)
        ) {
            shiftContent(shift)
        }
    }
    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        containerColor = Cream,
        topBar = {
            val calendarLabel = stringResource(Res.string.add_to_calendar)
            val profileLabel = stringResource(Res.string.dashboard_profile)
            EvoTopBar(
                // SH-89: the workplace and the month are the bar's; the bottom bar says Schedule.
                onBack = onNavigateBack,
                showWorkplace = true,
                showMonth = true,
                actions = buildList {
                    add(helpAction(HelpPage.MY_SHIFTS))
                    // SH-45, SH-202: own shifts into the calendar app (into ⋮ on a phone when short of room).
                    add(TopBarAction(calendarLabel, Icons.Default.Event, { showCalendar = true }))
                    add(TopBarAction(profileLabel, Icons.Default.Person, onNavigateToProfile, collapsible = false))
                }
            )
        },
    ) { padding ->
        val widthClass = LocalWindowWidthClass.current
        val isExpanded = widthClass.isExpanded
        val maxWidth = when {
            paneMode -> widthClass.wideContentMaxWidth
            isExpanded -> WideContentMaxWidth
            else -> ListMaxWidth
        }
        // SH-130: each scrolling column fills the screen and centres its content (contentWidth
        // after the scroll), so the wheel scrolls it over the empty sides too.
        // SH-168: pulling down reads the months and shifts again.
        PullToRefreshBox(
            isRefreshing = state.isRefreshing,
            onRefresh = { viewModel.onEvent(ScheduleEvent.Refresh) },
            modifier = Modifier.fillMaxSize().padding(padding)
        ) {
            val loadError = state.loadError
            if (loadError != null && state.shifts.isEmpty()) {
                // SH-168: the schedule could not be read: not an empty month, Try again.
                com.evoapps.evoshift.widgets.ErrorState(loadError, onRetry = { viewModel.onEvent(ScheduleEvent.Refresh) })
            } else
            // Only before there is anything to show: a refresh after a save keeps the calendar.
            if (state.isLoading && state.shifts.isEmpty() && !state.isRefreshing) {
                CircularProgressIndicator(
                    color = DarkGold,
                    modifier = Modifier.align(Alignment.Center)
                )
            } else {
                val currentRoster = state.publishedRosters.find { it.id == state.currentRosterId }
                val daysInMonth = remember(currentRoster?.year, currentRoster?.month) {
                    currentRoster?.let { getDaysInMonth(it.year, it.month) }.orEmpty()
                }
                // The month to pick a day from, and the shifts (mine, or the marketplace's).
                val calendarPane: @Composable ColumnScope.() -> Unit = {
                    Column(
                        modifier = if (isExpanded) {
                            Modifier
                                .fillMaxWidth()
                                .clip(RoundedCornerShape(20.dp))
                                .background(Color.White)
                                .border(1.dp, DarkGold.copy(alpha = 0.25f), RoundedCornerShape(20.dp))
                                .padding(20.dp)
                        } else Modifier
                    ) {
                        // Per-day markers computed once per change of the shifts, not per cell.
                        val dayFlags = remember(state.shifts, state.currentUserId) {
                            state.shifts.groupBy { it.date.takeLast(2).toIntOrNull() ?: 0 }
                                .mapValues { (_, dayShifts) ->
                                    CalendarDayFlags(
                                        hasMyShift = dayShifts.any { it.workerId == state.currentUserId },
                                        hasAnyShift = true,
                                        hasMarketplaceShift = dayShifts.any { it.swapRequest != null }
                                    )
                                }
                        }
                        val dayOfWeekLabelsRes = listOf(
                            Res.string.day_monday,
                            Res.string.day_tuesday,
                            Res.string.day_wednesday,
                            Res.string.day_thursday,
                            Res.string.day_friday,
                            Res.string.day_saturday,
                            Res.string.day_sunday
                        )
                        val dayOrder = (0..6).map { (it + state.firstDayOfWeek - 1) % 7 + 1 }
                        val offset = daysInMonth.firstOrNull()
                            ?.let { (it.dayOfWeek.isoDayNumber - state.firstDayOfWeek + 7) % 7 } ?: 0
                        // Plain rows, not a fixed-height lazy grid: six-week months fit.
                        val cells: List<LocalDate?> = List(offset) { null } + daysInMonth
                        val openDay: (LocalDate) -> Unit = { date ->
                            calendar.cursor = date
                            viewModel.onEvent(ScheduleEvent.SelectDay(date.day))
                        }
                        Column(
                            verticalArrangement = Arrangement.spacedBy(8.dp),
                            modifier = Modifier.monthCalendarKeys(
                                calendar, daysInMonth, state.firstDayOfWeek, AppClock.today(), onOpen = openDay
                            )
                        ) {
                            Row(Modifier.fillMaxWidth()) {
                                dayOrder.forEach { isoDayNum ->
                                    Text(
                                        text = stringResource(dayOfWeekLabelsRes[isoDayNum - 1]).take(3),
                                        style = MaterialTheme.typography.labelMedium,
                                        textAlign = TextAlign.Center,
                                        color = Color.Gray,
                                        modifier = Modifier.weight(1f)
                                    )
                                }
                            }
                            cells.chunked(7).forEach { week ->
                                Row(Modifier.fillMaxWidth()) {
                                    (0 until 7).forEach { i ->
                                        val date = week.getOrNull(i)
                                        Box(
                                            Modifier.weight(1f).then(if (date != null) Modifier.monthCalendarDay(date) else Modifier),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            if (date != null) {
                                                val flags = dayFlags[date.day]
                                                CalendarDayCircle(
                                                    day = date.day,
                                                    hasMyShift = flags?.hasMyShift == true,
                                                    hasAnyShift = flags?.hasAnyShift == true,
                                                    hasMarketplaceShift = flags?.hasMarketplaceShift == true,
                                                    onClick = { openDay(date) }
                                                )
                                                if (calendar.ringOn(date)) CalendarFocusRing(52.dp)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                val listPane: @Composable ColumnScope.() -> Unit = {
                    // One child, so the stacked TwoPane spacing stays between the panes only.
                    Column {
                        Row(
                            modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Text(
                                text = if (showMarketplaceOnly) stringResource(Res.string.schedule_marketplace_shifts) else stringResource(Res.string.schedule_my_shifts),
                                style = MaterialTheme.typography.titleMedium,
                                fontWeight = FontWeight.Bold,
                                color = DeepNavy
                            )

                            if (state.marketplaceShifts.isNotEmpty()) {
                                // SH-158: the toggle's colour and label change smoothly.
                                val toggleColor by animateColorAsState(
                                    if (showMarketplaceOnly) DeepNavy else DarkGold.copy(alpha = 0.1f),
                                    motionTween(),
                                    label = "marketToggle"
                                )
                                MotionContent(
                                    showMarketplaceOnly,
                                    Modifier
                                        .clip(RoundedCornerShape(16.dp))
                                        .background(toggleColor)
                                        .handCursor()
                                        .clickable { showMarketplaceOnly = !showMarketplaceOnly },
                                    label = "marketToggleLabel"
                                ) { marketOnly ->
                                    Row(
                                        modifier = Modifier.padding(horizontal = 12.dp, vertical = 6.dp),
                                        verticalAlignment = Alignment.CenterVertically,
                                        horizontalArrangement = Arrangement.spacedBy(4.dp)
                                    ) {
                                        if (!marketOnly) {
                                            Icon(
                                                Icons.Default.ShoppingBag,
                                                contentDescription = null,
                                                tint = DarkGold,
                                                modifier = Modifier.size(16.dp)
                                            )
                                            Text(
                                                text = pluralStringResource(Res.plurals.schedule_available_count, state.marketplaceShifts.size, state.marketplaceShifts.size),
                                                style = MaterialTheme.typography.labelMedium,
                                                color = DarkGold,
                                                fontWeight = FontWeight.Bold
                                            )
                                        } else {
                                            Text(
                                                text = stringResource(Res.string.schedule_show_my_shifts),
                                                style = MaterialTheme.typography.labelMedium,
                                                color = Color.White,
                                                fontWeight = FontWeight.Bold
                                            )
                                        }
                                    }
                                }
                            }
                        }

                        // SH-158: my shifts and the marketplace fade into each other; within a list a
                        // shift taken or given away slides the others.
                        MotionContent(showMarketplaceOnly, Modifier.fillMaxWidth(), label = "scheduleList") { marketOnly ->
                            if (marketOnly) {
                                if (state.marketplaceShifts.isEmpty()) {
                                    Text(stringResource(Res.string.schedule_marketplace_empty), color = Color.Gray)
                                } else {
                                    Column(Modifier.motionContentSize(), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                                        state.marketplaceShifts.forEach { shift ->
                                            key(shift.id) {
                                                Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                                                    ShiftItemCard(
                                                        shift = shift,
                                                        isMyShift = false,
                                                        showDate = true,
                                                        onClick = { viewModel.onEvent(ScheduleEvent.SelectShift(shift)) }
                                                    )
                                                    // SH-165: what taking it would do to the month's pay.
                                                    PayChangeLine(
                                                        state.payChanges[shift.id], state.currency,
                                                        modifier = Modifier.padding(horizontal = 8.dp),
                                                        color = MaterialTheme.colorScheme.onBackground.copy(alpha = 0.8f)
                                                    )
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                // SH-210: the month's job interviews this person takes part in, violet.
                                val interviews = state.myInterviews.filter { it.rosterId == state.currentRosterId }
                                if (interviews.isNotEmpty()) {
                                    Column(Modifier.padding(bottom = 8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                                        interviews.forEach { interview -> key(interview.id) { MyInterviewItem(interview) } }
                                    }
                                }
                                if (state.myShifts.isEmpty()) {
                                    if (interviews.isEmpty()) Text(stringResource(Res.string.schedule_no_shifts), color = Color.Gray)
                                } else {
                                    Column(Modifier.motionContentSize(), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                                        state.myShifts.forEach { shift ->
                                            key(shift.id) {
                                                if (shift.swapRequest != null) {
                                                    MyShiftMarketplaceItem(
                                                        shift = shift,
                                                        onClick = { viewModel.onEvent(ScheduleEvent.SelectShift(shift)) }
                                                    )
                                                } else {
                                                    MyShiftItem(
                                                        shift = shift,
                                                        onClick = { viewModel.onEvent(ScheduleEvent.SelectShift(shift)) },
                                                        workMarks = state.workMarksOn(shift.date),
                                                        place = state.places[shift.id]
                                                    )
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                // SH-102: on a foldable the shifts sit above the hinge (left when flat and nearly
                // square) and the month to pick a day from below it, in reach.
                PostureAwareScaffold(
                    controls = if (currentRoster == null) null else {
                        {
                            Column(Modifier.fillMaxSize().verticalScroll(rememberScrollState()).contentWidth(maxWidth).padding(16.dp)) { calendarPane() }
                        }
                    },
                    content = {
                        Column(Modifier.fillMaxSize().verticalScroll(rememberScrollState()).contentWidth(maxWidth).padding(16.dp)) { listPane() }
                    },
                    normal = {
                    if (!(paneMode && currentRoster != null)) Column(modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState()).contentWidth(maxWidth)) {
                        if (currentRoster == null) {
                            Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                                // SH-89: the top bar's month has no published roster (others may).
                                val barMonth = LocalTopBarSelection.current?.month
                                Text(
                                    if (barMonth != null && state.publishedRosters.isNotEmpty()) {
                                        stringResource(Res.string.top_bar_no_roster, "${com.evoapps.evoshift.ui.util.monthName(barMonth.month.number)} ${barMonth.year}")
                                    } else stringResource(Res.string.schedule_no_rosters),
                                    style = MaterialTheme.typography.bodyLarge,
                                    color = Color.Gray
                                )
                            }
                        } else {
                            // Wide windows: the month on the left, the list on the right. Phones and small
                            // tablets stack them exactly as before (TwoPane spacing = the old 24dp spacer).
                            TwoPane(
                                modifier = Modifier.padding(if (isExpanded) 24.dp else 16.dp),
                                firstWeight = 0.55f,
                                first = { calendarPane() },
                                second = { listPane() }
                            )
                        }
                    }
                    if (paneMode && currentRoster != null) {
                        // SH-105: the month and the list (side by side where they fit, else one
                        // above the other) and the chosen day or shift in a pane on the right.
                        val detailWeight = if (widthClass.isLarge) 0.32f else 0.42f
                        // SH-136: the panes fill the window (a capped row left dead margins on very
                        // wide windows); the month and the list keep their width inside the scroll.
                        Row(Modifier.fillMaxSize()) {
                            ProvideWindowWidthClass(Modifier.weight(1f - detailWeight).fillMaxHeight().testTag(PaneTags.LIST), posture = DevicePosture.Normal) {
                                Column(Modifier.fillMaxSize().verticalScroll(rememberScrollState()).contentWidth(maxWidth)) {
                                    TwoPane(
                                        modifier = Modifier.padding(24.dp),
                                        firstWeight = 0.55f,
                                        first = { calendarPane() },
                                        second = { listPane() }
                                    )
                                }
                            }
                            PaneDivider()
                            Box(Modifier.weight(detailWeight).fillMaxHeight().testTag(PaneTags.DETAIL)) {
                                val shift = state.selectedShift
                                when {
                                    shift != null -> {
                                        DetailPaneBack(onClose = { viewModel.onEvent(ScheduleEvent.SelectShift(null)) })
                                        DetailPane(
                                            title = shiftTitle(shift),
                                            icon = shiftIcon(shift),
                                            onClose = { viewModel.onEvent(ScheduleEvent.SelectShift(null)) },
                                            modifier = Modifier.fillMaxSize()
                                        ) { shiftContent(shift) }
                                    }
                                    state.selectedDay != null -> {
                                        DetailPaneBack(onClose = { viewModel.onEvent(ScheduleEvent.ClearDay) })
                                        DetailPane(
                                            title = dayTitle,
                                            icon = Icons.Default.CalendarToday,
                                            onClose = { viewModel.onEvent(ScheduleEvent.ClearDay) },
                                            modifier = Modifier.fillMaxSize()
                                        ) { dayContent() }
                                    }
                                    else -> Box(Modifier.fillMaxSize().testTag(PaneTags.PLACEHOLDER)) {
                                        PanePlaceholder(stringResource(Res.string.wide_pick_shift), Icons.Default.CalendarToday)
                                    }
                                }
                            }
                        }
                    }
                    }
                )
            }
        }
    }
}

@Composable
fun CalendarDayCircle(
    day: Int,
    hasMyShift: Boolean,
    hasAnyShift: Boolean,
    hasMarketplaceShift: Boolean = false,
    onClick: () -> Unit
) {
    val bgColor = when {
        hasMyShift -> DeepNavy
        hasMarketplaceShift -> DarkGold
        hasAnyShift -> Color.White
        else -> Color.Transparent
    }
    val textColor = when {
        hasMyShift -> Color.White
        hasMarketplaceShift -> DeepNavy
        else -> DeepNavy
    }
    val borderModifier = if (hasAnyShift && !hasMyShift && !hasMarketplaceShift) {
        Modifier.border(1.dp, DeepNavy.copy(alpha = 0.3f), CircleShape)
    } else Modifier

    // The grid gives each cell the column width; keep the day a circle centred in it.
    Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
    Box(
        modifier = Modifier
            // SH-163: a 48 dp target around the same 44 dp circle.
            .minimumInteractiveComponentSize()
            .size(44.dp)
            .clip(CircleShape)
            .background(bgColor)
            .then(borderModifier)
            .handCursor()
            .clickable(onClick = onClick),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = day.toString(),
            color = textColor,
            fontWeight = FontWeight.Bold,
            fontSize = 16.sp
        )
        if (hasMyShift) {
            Box(
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .padding(bottom = 6.dp)
                    .size(4.dp)
                    .clip(CircleShape)
                    .background(DarkGold)
            )
        } else if (hasAnyShift) {
            Box(
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .padding(bottom = 6.dp)
                    .size(4.dp)
                    .clip(CircleShape)
                    .background(DeepNavy.copy(alpha = 0.5f))
            )
        }
    }
    }
}

@Composable
fun ShiftItemCard(
    shift: Shift, isMyShift: Boolean, showDate: Boolean = false, onClick: () -> Unit = {},
    /** SH-223: remote work or a work event that day. */
    workMarks: Set<com.evoapps.evoshift.domain.model.WorkRequestKind> = emptySet(),
    /** SH-267: another workplace of the group (its name and address) where the person is planned. */
    place: String? = null
) {
    val containerColor = if (isMyShift) DeepNavy else Color(0xFFF7F2E9)
    val textColor = if (isMyShift) Color.White else DeepNavy
    val labelColor = if (isMyShift) DarkGold else DeepNavy.copy(alpha = 0.7f)

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .background(containerColor, RoundedCornerShape(12.dp))
            .border(
                1.dp,
                if (isMyShift) DarkGold else Color.Transparent,
                RoundedCornerShape(12.dp)
            )
            .cardClickable(RoundedCornerShape(12.dp), tint = if (isMyShift) Color.White else DeepNavy, onClick = onClick)
            .padding(16.dp)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        if (isMyShift) Icons.Default.Person else Icons.Default.Work,
                        contentDescription = null,
                        tint = labelColor,
                        modifier = Modifier.size(16.dp)
                    )
                    Spacer(Modifier.width(6.dp))

                    val displayName = when {
                        // SH-235: the shared label when the name could not be read.
                        shift.userId != null -> com.evoapps.evoshift.ui.util.personName(shift.userDisplayName)
                        else -> stringResource(Res.string.schedule_open_shift)
                    }

                    Text(
                        text = displayName ?: stringResource(Res.string.schedule_open_shift),
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.Bold,
                        color = textColor
                    )
                }
                Spacer(Modifier.height(4.dp))
                if (showDate) {
                    Text(
                        text = dayAndDate(LocalDate.parse(shift.date)),
                        style = MaterialTheme.typography.bodySmall,
                        fontWeight = FontWeight.Bold,
                        color = labelColor
                    )
                }
                shift.requiredRole?.let { role ->
                    Text(
                        text = role,
                        style = MaterialTheme.typography.bodySmall,
                        color = labelColor
                    )
                }
                place?.let {
                    Text(stringResource(Res.string.schedule_shift_at, it), style = MaterialTheme.typography.bodySmall, color = labelColor)
                }
            }

            Column(horizontalAlignment = Alignment.End) {
                val start = shift.plannedTime.start.substring(11, 16)
                val end = shift.plannedTime.end.substring(11, 16)
                Text(
                    text = "$start - $end",
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.Bold,
                    color = textColor
                )
                if (isMyShift) {
                    Text(
                        text = stringResource(Res.string.schedule_my_shift),
                        style = MaterialTheme.typography.labelSmall,
                        fontWeight = FontWeight.Bold,
                        color = DarkGold
                    )
                }
                if (workMarks.isNotEmpty()) WorkMarkChip(workMarks, if (isMyShift) LightGold else DeepNavy)
            }
        }
    }
}

/** SH-165: test tags of the swap picker. */
/** SH-165: the test tag of a pay change line ([PayChangeLine]), by shift id. */
object PayChangeTags {
    fun line(shiftId: String) = "pay_change_$shiftId"
}

/** "−192,00 zł" / "+160,00 zł": a change of pay with its sign (a true minus). */
fun formatPayDelta(amount: Double, currency: String): String =
    if (amount < 0) "−" + formatMoney(-amount, currency) else "+" + formatMoney(amount, currency)

/**
 * SH-165: "Your estimated take-home pay in October: −192,00 zł (from 3 840,00 zł to 3 648,00 zł)",
 * what giving away, swapping or taking a shift does to the person's own estimate (the dashboard's
 * card), worked out by the domain; tapped, it shows the calculation. A salary the shift does not
 * change says so; nothing without pay terms the person can read.
 */
@Composable
fun PayChangeLine(
    change: ShiftPayChange?,
    currency: String,
    modifier: Modifier = Modifier,
    color: Color = Color.White.copy(alpha = 0.9f)
) {
    if (change == null) return
    val month = inMonth(change.month)
    val style = MaterialTheme.typography.bodyMedium
    val tagged = modifier.testTag(PayChangeTags.line(change.shiftId))
    when {
        change.isUnchanged && change.salaried ->
            Text(stringResource(Res.string.pay_change_salaried, month), style = style, color = color, modifier = tagged)
        change.isUnchanged -> Unit
        else -> com.evoapps.evoshift.ui.finance.ExplainableAmount(
            text = stringResource(
                Res.string.pay_change_line, month, formatPayDelta(change.delta, currency),
                formatMoney(change.before, currency), formatMoney(change.after, currency)
            ),
            calculation = change.calculation,
            currency = currency,
            modifier = tagged,
            style = style,
            color = color,
            animated = true
        )
    }
}

object SwapPickerTags {
    const val NOTE = "swap_note"
    fun candidate(uid: String) = "swap_candidate_$uid"
}

/**
 * Giving a shift away: onto the marketplace, or to a chosen colleague. SH-165: an optional note goes
 * with either; the colleagues come best first ([candidates]: available and free that day first,
 * each marked), limited to the shift's [role]; null while they load.
 */
@Composable
fun SwapOptionsDialog(
    candidates: List<com.evoapps.evoshift.domain.usecase.marketplace.SwapCandidate>?,
    role: String?,
    onDismiss: () -> Unit,
    onPutOnMarketplace: (note: String?) -> Unit,
    onSwapWithPerson: (userId: String, note: String?) -> Unit,
    /** SH-165: what giving the shift away does to the person's estimated pay; nothing shown without it. */
    payChange: ShiftPayChange? = null,
    currency: String = "PLN"
) {
    var showPersonSelector by remember { mutableStateOf(false) }
    var note by remember { mutableStateOf("") }
    val noteOrNull = note.trim().takeIf { it.isNotEmpty() }

    EvoDialog(
        title = stringResource(Res.string.schedule_swap_change),
        subtitle = if (showPersonSelector) stringResource(Res.string.schedule_select_person) else null,
        icon = Icons.Default.SwapHoriz,
        onDismiss = onDismiss,
        width = DialogWidth.Compact,
        dismiss = if (showPersonSelector) DialogAction(stringResource(Res.string.back), { showPersonSelector = false })
        else DialogAction(stringResource(Res.string.cancel), onDismiss),
        bodyArrangement = Arrangement.spacedBy(if (showPersonSelector) 8.dp else 12.dp)
    ) {
        // SH-165: before either choice, what it does to the month's pay.
        PayChangeLine(payChange, currency)
        if (!showPersonSelector) {
            EvoTextField(
                value = note,
                onValueChange = { note = it.take(com.evoapps.evoshift.domain.model.SwapRequest.MAX_NOTE) },
                label = stringResource(Res.string.swap_note_label),
                placeholder = stringResource(Res.string.swap_note_placeholder),
                singleLine = false,
                imeAction = ImeAction.Default,
                modifier = Modifier.fillMaxWidth().testTag(SwapPickerTags.NOTE)
            )
            EvoPrimaryButton(
                DialogAction(stringResource(Res.string.schedule_put_on_marketplace), { onPutOnMarketplace(noteOrNull) }, icon = Icons.Default.Storefront),
                Modifier.fillMaxWidth()
            )
            EvoSecondaryButton(
                DialogAction(stringResource(Res.string.schedule_swap_with_person), { showPersonSelector = true }, icon = Icons.Default.Person),
                Modifier.fillMaxWidth()
            )
        } else {
            if (role != null) {
                Text(stringResource(Res.string.swap_candidates_role, role), color = Color.White.copy(alpha = 0.75f), style = MaterialTheme.typography.bodySmall)
            }
            when {
                candidates == null -> CircularProgressIndicator(color = LightGold, modifier = Modifier.align(Alignment.CenterHorizontally))
                candidates.isEmpty() -> Text(stringResource(Res.string.swap_candidates_none), color = Color.White.copy(alpha = 0.85f))
                else -> candidates.forEach { candidate ->
                    EvoListRow(
                        headline = candidate.user.displayName,
                        supporting = swapCandidateLabel(candidate.status),
                        leadingIcon = Icons.Default.Person,
                        modifier = Modifier.testTag(SwapPickerTags.candidate(candidate.user.uid)),
                        onClick = { onSwapWithPerson(candidate.user.uid, noteOrNull) }
                    )
                }
            }
        }
    }
}

/** SH-165: "Available", "Working that day", "Unavailable", "No answer". */
@Composable
fun swapCandidateLabel(status: com.evoapps.evoshift.domain.usecase.marketplace.SwapCandidateStatus): String = stringResource(
    when (status) {
        com.evoapps.evoshift.domain.usecase.marketplace.SwapCandidateStatus.AVAILABLE -> Res.string.swap_candidate_available
        com.evoapps.evoshift.domain.usecase.marketplace.SwapCandidateStatus.NO_ANSWER -> Res.string.swap_candidate_no_answer
        com.evoapps.evoshift.domain.usecase.marketplace.SwapCandidateStatus.UNAVAILABLE -> Res.string.swap_candidate_unavailable
        com.evoapps.evoshift.domain.usecase.marketplace.SwapCandidateStatus.WORKING -> Res.string.swap_candidate_working
    }
)

@Composable
fun MyShiftMarketplaceItem(shift: Shift, onClick: () -> Unit = {}) {
    val swap = shift.swapRequest ?: return
    Card(
        modifier = Modifier.fillMaxWidth().cardClickable(CardDefaults.shape, onClick = onClick),
        colors = CardDefaults.cardColors(containerColor = DarkGold.copy(alpha = 0.1f)),
        border = BorderStroke(1.dp, DarkGold)
    ) {
        Row(
            modifier = Modifier.padding(12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            val date = LocalDate.parse(shift.date)
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Text(
                    text = dayShort(date.dayOfWeek).uppercase(),
                    style = MaterialTheme.typography.labelSmall,
                    color = DeepNavy.copy(alpha = 0.7f)
                )
                Text(
                    text = date.day.toString(),
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
            }

            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = shift.requiredRole ?: stringResource(Res.string.shift),
                    style = MaterialTheme.typography.bodyLarge,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
                val start = shift.plannedTime.start.substring(11, 16)
                val end = shift.plannedTime.end.substring(11, 16)
                Text(
                    text = "$start - $end",
                    style = MaterialTheme.typography.bodyMedium,
                    color = DeepNavy.copy(alpha = 0.8f)
                )

                Spacer(Modifier.height(4.dp))

                val createdAtDate = swap.createdAt.substring(0, 10)
                val createdAtTime = swap.createdAt.substring(11, 16)
                val formattedCreatedAt = "$createdAtDate $createdAtTime"

                Text(
                    text = stringResource(Res.string.schedule_marketplace_request_at, formattedCreatedAt),
                    style = MaterialTheme.typography.labelSmall,
                    color = DarkGold,
                    fontWeight = FontWeight.Bold
                )

                if (swap.candidateUserId != null) {
                    Text(
                        text = stringResource(Res.string.schedule_waiting_for_approval_from, swap.candidateName ?: stringResource(Res.string.employee)),
                        style = MaterialTheme.typography.labelSmall,
                        color = DeepNavy.copy(alpha = 0.7f)
                    )
                }

                if (!swap.managerNote.isNullOrBlank()) {
                    Text(
                        text = stringResource(Res.string.schedule_manager_note, swap.managerNote ?: ""),
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.Red.copy(alpha = 0.7f)
                    )
                }
            }
            
            Column(horizontalAlignment = Alignment.End) {
                // SH-164: a rejected request says so (with the manager's note beside it).
                val rejected = swap.status == SwapStatus.REJECTED
                Text(
                    text = if (rejected) swap.status.label() else stringResource(Res.string.schedule_swap_status_requested),
                    style = MaterialTheme.typography.labelSmall,
                    fontWeight = FontWeight.Bold,
                    color = if (rejected) Color.Red.copy(alpha = 0.8f) else DarkGold
                )
            }
        }
    }
}

@Composable
fun MyShiftItem(
    shift: Shift, onClick: () -> Unit = {},
    /** SH-223: remote work or a work event that day. */
    workMarks: Set<com.evoapps.evoshift.domain.model.WorkRequestKind> = emptySet(),
    /** SH-267: another workplace of the group (its name and address) where the person is planned. */
    place: String? = null
) {
    Card(
        modifier = Modifier.fillMaxWidth().cardClickable(CardDefaults.shape, onClick = onClick),
        colors = CardDefaults.cardColors(containerColor = DeepNavy.copy(alpha = 0.05f))
    ) {
        Row(
            modifier = Modifier.padding(12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            val date = LocalDate.parse(shift.date)
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Text(
                    text = dayShort(date.dayOfWeek).uppercase(),
                    style = MaterialTheme.typography.labelSmall,
                    color = DeepNavy.copy(alpha = 0.7f)
                )
                Text(
                    text = date.day.toString(),
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
            }

            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = shift.requiredRole ?: stringResource(Res.string.shift),
                    style = MaterialTheme.typography.bodyLarge,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
                val start = shift.plannedTime.start.substring(11, 16)
                val end = shift.plannedTime.end.substring(11, 16)
                Text(
                    text = "$start - $end",
                    style = MaterialTheme.typography.bodyMedium,
                    color = DeepNavy.copy(alpha = 0.8f)
                )
                place?.let {
                    Text(stringResource(Res.string.schedule_shift_at, it), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.8f))
                }
            }
            if (workMarks.isNotEmpty()) WorkMarkChip(workMarks, DeepNavy)
        }
    }
}

/** Test tag of the schedule's remote-work or work-event chip. */
const val SCHEDULE_WORK_MARK_TAG = "schedule_work_mark"

/** SH-223: "Remote" with a house, or "At a work event", beside the shift's times. */
@Composable
fun WorkMarkChip(marks: Set<com.evoapps.evoshift.domain.model.WorkRequestKind>, color: Color) {
    val remote = com.evoapps.evoshift.domain.model.WorkRequestKind.REMOTE_WORK in marks
    Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.testTag(SCHEDULE_WORK_MARK_TAG).padding(top = 2.dp)) {
        Icon(if (remote) Icons.Default.Home else Icons.Default.Event, contentDescription = null, tint = color, modifier = Modifier.size(14.dp))
        Spacer(Modifier.width(4.dp))
        Text(stringResource(if (remote) Res.string.remote_badge else Res.string.event_badge), style = MaterialTheme.typography.labelSmall,
            fontWeight = FontWeight.Bold, color = color)
    }
}

/** What a calendar day shows: my shift, any shift, a swap on offer. */
private data class CalendarDayFlags(val hasMyShift: Boolean, val hasAnyShift: Boolean, val hasMarketplaceShift: Boolean)

/** The breaks registered on a shift: each one's times and length, and the total. Nothing when none. */
@Composable
fun MyBreaksList(breaks: List<ShiftBreak>, modifier: Modifier = Modifier, textColor: Color = Color.White) {
    if (breaks.isEmpty()) return
    val sorted = breaks.sortedBy { it.start }
    DialogSection(stringResource(Res.string.my_breaks_title)) {
        Column(modifier, verticalArrangement = Arrangement.spacedBy(4.dp)) {
            sorted.forEach { b ->
                val from = b.start.drop(11).take(5)
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text(
                        if (b.isOpen) stringResource(Res.string.my_break_ongoing, from)
                        else stringResource(Res.string.my_break_row, from, b.end.drop(11).take(5)),
                        color = textColor.copy(alpha = 0.9f)
                    )
                    if (!b.isOpen) {
                        val minutes = BreakRules.endedMinutes(listOf(b)).toInt()
                        Text(pluralStringResource(Res.plurals.my_break_minutes, minutes, minutes), color = textColor.copy(alpha = 0.7f))
                    }
                }
            }
            if (sorted.size > 1) {
                val total = BreakRules.endedMinutes(sorted).toInt()
                Text(
                    pluralStringResource(Res.plurals.my_breaks_total, total, total),
                    color = if (textColor == Color.White) LightGold else com.evoapps.evoshift.ui.DarkGold,
                    fontWeight = FontWeight.Bold
                )
            }
        }
    }
}


/** SH-210: the test tag of an interview in My shifts. */
fun myInterviewTag(interviewId: String) = "my_interview_$interviewId"

/** SH-210: one of the person's job interviews: "Job interview", the day, the times, where. */
@Composable
private fun MyInterviewItem(interview: com.evoapps.evoshift.domain.model.Interview) {
    val ink = com.evoapps.evoshift.ui.roster.InterviewInk
    Column(
        Modifier.fillMaxWidth()
            .clip(androidx.compose.foundation.shape.RoundedCornerShape(12.dp))
            .background(com.evoapps.evoshift.ui.roster.InterviewTint)
            .border(1.dp, ink.copy(alpha = 0.55f), androidx.compose.foundation.shape.RoundedCornerShape(12.dp))
            .padding(12.dp)
            .testTag(myInterviewTag(interview.id)),
        verticalArrangement = Arrangement.spacedBy(2.dp)
    ) {
        Text(
            stringResource(evoshift.composeapp.generated.resources.Res.string.interview_title) +
                (interview.jobTitle.takeIf { it.isNotBlank() }?.let { " · $it" } ?: ""),
            color = ink, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleSmall
        )
        Text(
            stringResource(evoshift.composeapp.generated.resources.Res.string.interview_when, interview.date, interview.startTime, interview.endTime),
            color = ink, style = MaterialTheme.typography.bodyMedium
        )
        listOfNotNull(interview.location, interview.onlineUrl).forEach { Text(it, color = ink, style = MaterialTheme.typography.bodySmall) }
        interview.candidateName?.let {
            Text(stringResource(evoshift.composeapp.generated.resources.Res.string.interview_candidate, it), color = ink, style = MaterialTheme.typography.bodySmall)
        }
    }
}

/** Test tags of the person's own hours (SH-257): the fields and "Wyślij godziny". */
const val SELF_HOURS_START_TAG = "self_hours_start"
const val SELF_HOURS_END_TAG = "self_hours_end"
const val SELF_HOURS_SEND_TAG = "self_hours_send"

/**
 * SH-257: "Wpisz godziny pracy" on the person's own shift, where the workplace lets the team enter
 * their hours: the start and end ([open]: today or the days allowed, before a manager confirmed
 * them) sent to a manager ([onSend]), or what was entered and whether a manager confirmed it.
 */
@Composable
private fun SelfEnteredHours(shift: Shift, open: Boolean, onSend: (TimeRange) -> Unit) {
    val actual = shift.actualTime?.takeIf { it.start.length >= 16 && it.end.length >= 16 }
    val span: (TimeRange) -> String = { "${it.start.substring(11, 16)}–${it.end.substring(11, 16)}" }
    val confirmed = shift.clockCheck?.review != null
    if (!open && actual == null) return
    DialogSection(stringResource(Res.string.schedule_enter_hours)) {
        when {
            confirmed && actual != null ->
                Text(stringResource(Res.string.schedule_hours_confirmed, span(actual)), color = Color.White.copy(alpha = 0.9f))
            !open && actual != null ->
                Text(stringResource(Res.string.schedule_hours_reported, span(actual)), color = Color.White.copy(alpha = 0.9f))
            else -> {
                if (actual != null && shift.clockAudit?.reportedByWorker == true) {
                    Text(stringResource(Res.string.schedule_hours_reported, span(actual)), color = LightGold)
                }
                val base = actual ?: shift.plannedTime
                var start by remember(shift.id) { mutableStateOf(base.start.substring(11, 16)) }
                var end by remember(shift.id) { mutableStateOf(base.end.substring(11, 16)) }
                val startClock = parseClockTime(start)
                val endClock = parseClockTime(end)
                val valid = startClock != null && endClock != null && startClock != endClock
                Text(stringResource(Res.string.schedule_enter_hours_hint), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.75f))
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    EvoTimeField(start, { start = it }, stringResource(Res.string.roster_from), Modifier.weight(1f).testTag(SELF_HOURS_START_TAG), showErrors = true)
                    EvoTimeField(
                        end, { end = it }, stringResource(Res.string.roster_to), Modifier.weight(1f).testTag(SELF_HOURS_END_TAG), showErrors = true,
                        error = stringResource(Res.string.time_same_start_end).takeIf { startClock != null && startClock == endClock },
                        imeAction = ImeAction.Done
                    )
                }
                EvoPrimaryButton(
                    DialogAction(
                        stringResource(Res.string.schedule_send_hours),
                        { if (startClock != null && endClock != null && valid) onSend(plannedTimeRange(LocalDate.parse(shift.date), startClock, endClock)) },
                        enabled = valid
                    ),
                    Modifier.fillMaxWidth().testTag(SELF_HOURS_SEND_TAG)
                )
            }
        }
    }
}
